import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  articles: {}
});

export function mergeArticles(state, eshop, article) {
  const arr = Array.isArray(article) ? article : [article];
  return state.mergeIn(
    ['articles'],
    fromJS(
      arr.reduce((obj, art) => ({ ...obj, [art.articleId]: { [eshop]: art } }), {})
    )
  );
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ESHOP_ARTICLES_SET':
      return mergeArticles(state, action.eshop, action.articles);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/eshop.js